import {
  REQUEST_CAMPAIGN_CATEGORY_LIST_WITH_CHILDREN
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestCampaignCategoryListWithChildren({commit}) {
    return axiosInst.springAxiosInst.get('/api/campaign-category/get-all-categories', {
    }).then((res) => {
      commit(REQUEST_CAMPAIGN_CATEGORY_LIST_WITH_CHILDREN, res.data)
    })
  }
}